import { render } from "./index.vue?vue&type=template&id=e50053cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&id=e50053cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e50053cc"

export default script